(function () {
  if (window.__faqInitialized) return;
  window.__faqInitialized = true;

  var initializedSections = new WeakSet();

  function setItemState(item, open) {
    var trigger = item.querySelector('[data-faq-trigger]');
    var answer = item.querySelector('[data-faq-answer]');
    if (!trigger || !answer) return;

    item.classList.toggle('is-open', open);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');

    if (open) {
      answer.style.height = answer.scrollHeight + 'px';
      var onEnd = function () {
        answer.style.height = 'auto';
        answer.removeEventListener('transitionend', onEnd);
      };
      answer.addEventListener('transitionend', onEnd);
    } else {
      answer.style.height = answer.scrollHeight + 'px';
      requestAnimationFrame(function () {
        answer.style.height = '0px';
      });
    }
  }

  function initReveal(root) {
    if (!('IntersectionObserver' in window)) {
      root.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('is-visible', entry.isIntersecting);
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -40px 0px' }
    );

    observer.observe(root);
  }

  function initSection(root) {
    if (!root || initializedSections.has(root)) return;
    initializedSections.add(root);

    var items = root.querySelectorAll('[data-faq-item]');

    items.forEach(function (item) {
      var isOpen = item.classList.contains('is-open');
      var answer = item.querySelector('[data-faq-answer]');
      if (answer) {
        answer.style.height = isOpen ? answer.scrollHeight + 'px' : '0px';
      }

      var trigger = item.querySelector('[data-faq-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var alreadyOpen = item.classList.contains('is-open');

        items.forEach(function (other) {
          if (other !== item) setItemState(other, false);
        });

        setItemState(item, !alreadyOpen);
      });
    });

    initReveal(root);
  }

  function initAll() {
    document.querySelectorAll('[data-faq]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-faq]');
    if (root) {
      initializedSections.delete(root);
      root.classList.remove('is-visible');
      initSection(root);
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest('[data-faq]');
    if (!root) return;
    var item = event.target.closest('[data-faq-item]');
    if (item) {
      root.querySelectorAll('[data-faq-item]').forEach(function (other) {
        if (other !== item) setItemState(other, false);
      });
      setItemState(item, true);
    }
  });
})();